import {
  CORE_API_LOG_REQUEST,
  CORE_API_LOG_SUCCESS,
  CORE_API_LOG_FAILURE,
  CORE_API_LOG_DETAIL_REQUEST,
  CORE_API_LOG_DETAIL_SUCCESS,
  CORE_API_LOG_DETAIL_FAILURE,
  CORE_API_LOG_NAMES_SUCCESS,
} from 'constants/ActionTypes'

const initialState = {
  isFetching: false,
  isFetchingDetail: false,
  dataCoreApiLog: [],
  metaCoreApiLog: {},
  detailCoreApiLog: null,
  apiNames: [],
}

export default function coreApiLog(state = initialState, action) {
  switch (action.type) {
    case CORE_API_LOG_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case CORE_API_LOG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        dataCoreApiLog: action.data || [],
        metaCoreApiLog: action.meta,
      }
    case CORE_API_LOG_FAILURE:
      return {
        ...state,
        isFetching: false,
        dataCoreApiLog: [],
        metaCoreApiLog: {},
        errorMessage: action.errorMessage,
      }
    case CORE_API_LOG_DETAIL_REQUEST:
      return {
        ...state,
        isFetchingDetail: true,
        detailCoreApiLog: null,
      }
    case CORE_API_LOG_DETAIL_SUCCESS:
      return {
        ...state,
        isFetchingDetail: false,
        detailCoreApiLog: action.data,
      }
    case CORE_API_LOG_DETAIL_FAILURE:
      return {
        ...state,
        isFetchingDetail: false,
        detailCoreApiLog: null,
        errorMessage: action.errorMessage,
      }
    case CORE_API_LOG_NAMES_SUCCESS:
      return {
        ...state,
        apiNames: action.data,
      }
    default:
      return state
  }
}
